import React, { useState, useEffect } from "react";
import { BLOGS } from "../../mock";
import { Calendar, Tag, ArrowRight, X } from "lucide-react";
import { Badge } from "../ui/badge";
import { SectionTitle } from "./About";
import { listBlogs } from "../../lib/api";

export default function Blog() {
  const [active, setActive] = useState(null);
  const [extra, setExtra] = useState([]);

  // Fetch admin-posted blogs from backend; default BLOGS mock is always shown.
  useEffect(() => {
    let mounted = true;
    listBlogs()
      .then((data) => { if (mounted) setExtra(data || []); })
      .catch(() => { /* silent — gracefully fall back to mock only */ });
    return () => { mounted = false; };
  }, []);

  const all = [...extra, ...BLOGS];
  const fmt = d => new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });

  return (
    <section id="blog" className="scroll-smooth-section py-24 bg-cream/40">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionTitle
          kicker="Writing"
          title="From the desk"
          subtitle="Reflections on neurology, philosophy, and the practice of medicine in Kerala."
        />

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {all.map(b => (
            <article key={b.id} className="bg-ivory rounded-2xl overflow-hidden border border-stone-200/60 lift flex flex-col">
              <div className="h-48 overflow-hidden bg-emerald-soft">
                {b.cover && <img src={b.cover} alt={b.title} className="w-full h-full object-cover" />}
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <div className="flex items-center gap-3 text-xs text-stone-500">
                  <span className="flex items-center gap-1"><Calendar className="w-3 h-3" /> {fmt(b.date)}</span>
                  <span className="flex items-center gap-1"><Tag className="w-3 h-3 text-gold" /> {b.category}</span>
                </div>
                <h3 className="font-display text-xl text-emerald-deep mt-3 leading-tight">{b.title}</h3>
                <p className="text-stone-600 text-sm mt-3 leading-relaxed flex-1">{b.excerpt}</p>
                <button onClick={() => setActive(b)} className="mt-5 inline-flex items-center gap-1 text-emerald-deep hover:text-gold transition-colors text-sm font-medium">
                  Read more <ArrowRight className="w-4 h-4" />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>

      {active && (
        <div className="fixed inset-0 z-[60] bg-stone-950/80 backdrop-blur flex items-center justify-center p-4" onClick={() => setActive(null)}>
          <div className="bg-ivory rounded-2xl max-w-2xl w-full max-h-[85vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
            {active.cover && <img src={active.cover} alt={active.title} className="w-full h-64 object-cover rounded-t-2xl" />}
            <div className="p-7">
              <div className="flex items-center justify-between gap-3">
                <Badge className="bg-emerald-deep text-ivory hover:bg-emerald-deep">{active.category}</Badge>
                <button onClick={() => setActive(null)} className="w-9 h-9 rounded-full bg-stone-100 hover:bg-stone-200 flex items-center justify-center"><X className="w-4 h-4" /></button>
              </div>
              <h3 className="font-display text-3xl text-emerald-deep mt-4 leading-tight">{active.title}</h3>
              <p className="text-xs text-stone-500 mt-2">{fmt(active.date)}</p>
              <p className="text-stone-700 mt-5 leading-relaxed whitespace-pre-line">{active.body}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
